export default __webpack_public_path__ + "static/media/oscer-pres-fever.fcfae3b2.svg";